import TagManager from 'react-gtm-module';

export const EVENTS = {
  // Existing legacy events
  purchase: 'purchase',
  subscriptionPlan: 'subscription_plan_selection',
  createAccount: 'account_created',
  loginAccount: 'login_account',
  promoCode: 'promo_code_applied',
  programPurchase: 'program_purchase',
  paymentAdded: 'payment_added',
  updateSubscription: 'update_subscription',
  changePlan: 'change_plan',
  challengeOptIn: 'challenge_opt_in',
  futureCommencement: 'future_commencement_opted',
  appstoreButtonClick: 'application_store_click',
  planSelected: 'plan_selected',
  fitHerProjectUser: 'fither_project_user_onboarded',
  fitHerUserAccountCreated: 'fit_her_user_account_created',
  fitHerUserSubscribed: 'fither_user_subscribed',
  viewItem: 'view_item',
  beginCheckout: 'begin_checkout',
  addPaymentInfo: 'add_payment_info',
  typeformSubmit: 'typeform_submit',
  quizStart: 'quiz_start',
  quizStep: 'quiz_step',
  quizComplete: 'quiz_complete',
  recipeEmailSubmitted: 'recipe_email_submitted',

  // Signup Funnel Step Events
  signupPlanSelectionViewed: 'signup_plan_selection_viewed',
  signupPlanSelected: 'signup_plan_selected',
  signupCheckoutStarted: 'signup_checkout_started',
  signupAccountStepViewed: 'signup_account_step_viewed',
  signupAccountCreated: 'signup_account_created',
  signupPaymentStepViewed: 'signup_payment_step_viewed',
  signupCheckoutSectionViewed: 'signup_checkout_section_viewed',
  signupPaymentMethodSelected: 'signup_payment_method_selected',
  signupPaymentSubmitted: 'signup_payment_submitted',
  signupPaymentFailed: 'signup_payment_failed',
  signupPaymentCompleted: 'signup_payment_completed',
  signupPurchaseCompleted: 'signup_purchase_completed',
  signupConfirmationViewed: 'signup_confirmation_viewed',

  // Subscription page pre-checkout upsell
  subscriptionUpsellViewed: 'subscription_upsell_viewed',
  subscriptionAddonSelected: 'subscription_addon_selected',
  subscriptionAddonRemoved: 'subscription_addon_removed',
  subscriptionUpsellDeclined: 'subscription_upsell_declined',

  // Checkout page upsell
  checkoutUpsellViewed: 'checkout_upsell_viewed',
  checkoutAddonSelected: 'checkout_addon_selected',
  checkoutAddonRemoved: 'checkout_addon_removed',

  // Post-purchase upsell (after base payment)
  postPurchaseUpsellViewed: 'post_purchase_upsell_viewed',
  postPurchaseAddonSelected: 'post_purchase_addon_selected',
  postPurchaseUpsellDeclined: 'post_purchase_upsell_declined',

  // Standalone Addon Flow (Existing user addon journey in My Account)
  addonViewed: 'addon_viewed',
  addonSelected: 'addon_selected',
  addonRemoved: 'addon_removed',
  addonPaymentStepViewed: 'addon_payment_step_viewed',
  addonPaymentMethodSelected: 'addon_payment_method_selected',
  addonPaymentSubmitted: 'addon_payment_submitted',
  addonPaymentFailed: 'addon_payment_failed',
  addonPaymentCompleted: 'addon_payment_completed',
  addonPurchaseCompleted: 'addon_purchase_completed',

  // Quiz Funnel Events
  quizResultsAccessSubmitted: 'quiz_results_access_submitted',
  quizResultsViewed: 'quiz_results_viewed',
  quizResultsCtaClicked: 'quiz_results_cta_clicked',

  // Promo code events on payment page
  promoCodeApplied: 'promo_code_applied',
  promoCodeSuccess: 'promo_code_success',
  promoCodeFailed: 'promo_code_failed',
};

/**
 * Track function for tracking
 *
 * @param eventName
 * @param properties
 * @returns
 */
export function track(
  eventName: string,
  properties?: { [key: string]: any } | undefined
) {
  if (process.env.CONSOLE_LOG_EVENTS === 'true') {
    console.log(eventName, properties);
  }

  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...properties,
    },
  });
}

export {
  trackSignupFunnel,
  trackQuizFunnel,
  trackReactivationFunnel,
  trackSignupPlanSelectionViewed,
  trackSignupPlanSelected,
  trackSignupCheckoutStarted,
  trackSignupAccountStepViewed,
  trackSignupAccountCreated,
  trackSignupPaymentStepViewed,
  trackSignupCheckoutSectionViewed,
  trackSignupPaymentMethodSelected,
  trackSignupPaymentSubmitted,
  trackSignupPaymentFailed,
  trackSignupPaymentCompleted,
  trackSignupPurchaseCompleted,
  trackSubscriptionUpsellViewed,
  trackSubscriptionAddonToggle,
  trackSubscriptionUpsellDeclined,
  trackCheckoutUpsellViewed,
  trackCheckoutAddonToggle,
  trackPostPurchaseUpsellViewed,
  trackPromoCodeApplied,
  trackPromoCodeSuccess,
  trackPromoCodeFailed,
  trackPostPurchaseAddonSelected,
  trackPostPurchaseUpsellDeclined,
  trackAddonViewed,
  trackAddonSelected,
  trackAddonRemoved,
  trackAddonPaymentStepViewed,
  trackAddonPaymentMethodSelected,
  trackAddonPaymentSubmitted,
  trackAddonPaymentFailed,
  trackAddonPaymentCompleted,
  trackAddonPurchaseCompleted,
  trackReactivationViewed,
  trackReactivationSubmitted,
  trackReactivationFailed,
  trackReactivationCompleted,
  trackReactivationPlanSelected,
} from './track.util';
